// Only continue to local application pages, never an external or another auth URL.
export const safeReturnPath = (value, fallback = '/dashboard') => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return fallback;
  }
  let decoded;
  try {
    decoded = decodeURIComponent(value);
  } catch {
    return fallback;
  }
  if (
    decoded.startsWith('//') ||
    decoded.includes('\\') ||
    [...decoded].some(
      character => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127
    ) ||
    /^\/(login|register|forgot-password|reset-password|verify-email)(?:[/?#]|$)/i.test(
      new URL(value, 'https://local.invalid').pathname
    )
  ) {
    return fallback;
  }
  return value;
};
